import {useGrid, UseGridReturnType} from "common";

import {
  getLocationService, getLocationLimit,
  LocationFormItem,
  LocationListItem,
} from "./locationApi";
import {createContext, useEffect, useState} from "react";

export type UseLocationListReturnType = {
  grid: UseGridReturnType;
  locationLimit: number;
  locationCount: number;
  canAddLocation: boolean;
}

export const LocationListContext = createContext<UseLocationListReturnType>(
  {} as UseLocationListReturnType
);

export default function useLocationList(): UseLocationListReturnType {
  const service = getLocationService();
  const grid = useGrid<LocationFormItem, LocationListItem>({
    comaSeparatedSortPrarms: true,
    storageType: "urlParams",
    id: "Locations",
    loadColumns: true,
    translationCategory: "Location",

    exportFilter: filter => ({
      ClientSearch: filter,
    }),
    ...service,
  });

  const [locationLimit, setLocationLimit] = useState(0);
  const [locationCount, setLocationCount] = useState(0);
  const [canAddLocation, setCanAddLocation] = useState(false);

  useEffect(() => {
    updateLocationLimit();
  }, []);

  async function updateLocationLimit() {
    const result = await getLocationLimit();

    if (result?.data?.data) {
      const resultLimit = result.data.data?.limit;
      const resultCount = result.data.data?.count;
      setLocationLimit(resultLimit);
      setLocationCount(resultCount);

      setCanAddLocation(resultCount < resultLimit);
    } else {
      setCanAddLocation(false);
    }
  }

  return {
    grid,
    locationLimit,
    locationCount,
    canAddLocation,
  };
}
